/* eslint-disable no-unused-vars */

/* eslint-disable @typescript-eslint/no-unused-vars */
import React from "react";
import {
  Animated, Platform, StyleProp, StyleSheet, TextStyle, View, ViewStyle
} from "react-native";
import SVG_Svg, {
  G as SVG_G, GProps, Path as SVG_Path, PathProps
} from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: desc */

/***/

const Path = Animated.createAnimatedComponent<
  React.ComponentClass<
    PathProps & {
      style?: StyleProp<ViewStyle>;
    }
  >
>(SVG_Path);
const G = Animated.createAnimatedComponent<
  React.ComponentClass<
    GProps & {
      style?: StyleProp<ViewStyle>;
    }
  >
>(SVG_G);
const Svg = Animated.createAnimatedComponent(SVG_Svg);

/*
 * -------------------------------------------------------------------------
 *
 *  /$$$$$$                                /$$$$$$$  /$$
 * |_  $$_/                               | $$__  $$| $$
 *   | $$   /$$$$$$/$$$$   /$$$$$$        | $$  \ $$| $$ /$$   /$$  /$$$$$$
 *   | $$  | $$_  $$_  $$ /$$__  $$       | $$$$$$$ | $$| $$  | $$ /$$__  $$
 *   | $$  | $$ \ $$ \ $$| $$  \ $$       | $$__  $$| $$| $$  | $$| $$$$$$$$
 *   | $$  | $$ | $$ | $$| $$  | $$       | $$  \ $$| $$| $$  | $$| $$_____/
 *  /$$$$$$| $$ | $$ | $$| $$$$$$$/  /$$  | $$$$$$$/| $$|  $$$$$$/|  $$$$$$$
 * |______/|__/ |__/ |__/| $$____/  |__/  |_______/ |__/ \______/  \_______/
 *                       | $$
 *                       | $$
 *                       |__/
 *
 * -------------------------------------------------------------------------
 *
 * ORIGINAL SVG
 * ---------------------------------
 * <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none"> <desc id="IMP.BLUE">{"#Group_2052":{"type":"SELECTOR","constraint":"none","width":20.000211715698242,"height":20},"#Vector":{"type":"SELECTOR","constraint":"none","width":16.428571701049805,"height":8.571428298950195},"#Rectangle_20294":{"type":"SELECTOR","constraint":"none","width":20,"height":10},"transforms":{},"tProps":{"type":"PROPS","onAnimationComplete?":"() => void"},"#Import_Sm":{"type":"SELECTOR","constraint":"none","width":40,"height":40},"#Rectangle_20293":{"type":"SELECTOR","constraint":"none","width":40,"height":40}}</desc>
 * <g id="Import_Sm">
 * <rect id="Rectangle 293" x="39.5" y="0.5" width="39" height="39" rx="1.5" transform="rotate(90 39.5 0.5)" stroke="#2C4B46"/>
 * <g id="Group 52">
 * <path id="Vector" d="M19.923 11.9811L19.923 10.8561L19.088 11.6099L16.5539 13.8976C16.5375 13.9124 16.5125 13.9124 16.496 13.8976C16.477 13.8804 16.477 13.8506 16.496 13.8334L19.9965 10.6733L23.5036 13.8337C23.5227 13.8509 23.5227 13.8808 23.5037 13.898C23.4872 13.9128 23.4622 13.9128 23.4457 13.898L20.904 11.6095L20.0694 10.8581L20.0694 11.9811L20.0694 25.8553C20.0694 25.8958 20.0366 25.9285 19.9962 25.9285C19.9558 25.9285 19.923 25.8958 19.923 25.8553L19.923 11.9811Z" fill="#2C4B46" stroke="#2C4B46"/>
 * <path id="Rectangle 294" d="M14 20.0002H10V30.0002H30V20.0002H26" stroke="#2C4B46" stroke-linecap="round" stroke-linejoin="round"/>
 * </g>
 * <path d="M2 1H38V-1H2V1ZM39 2V38H41V2H39ZM38 39H2V41H38V39ZM1 38V2H-1V38H1ZM2 39C1.44772 39 1 38.5523 1 38H-1C-1 39.6569 0.343147 41 2 41V39ZM39 38C39 38.5523 38.5523 39 38 39V41C39.6569 41 41 39.6569 41 38H39ZM38 1C38.5523 1 39 1.44772 39 2H41C41 0.343146 39.6569 -1 38 -1V1ZM2 -1C0.343146 -1 -1 0.343147 -1 2H1C1 1.44772 1.44772 1 2 1V-1Z" fill="#2C4B46"/>
 * </g>
 * </svg>
 *
 * ---------------------------------
 *
 * CONFIGURATION
 * ---------------------------------
 * {
 * 	"#Group_2052": {
 * 		"type": "SELECTOR",
 * 		"constraint": "none",
 * 		"width": 20.000211715698242,
 * 		"height": 20
 * 	},
 * 	"#Vector": {
 * 		"type": "SELECTOR",
 * 		"constraint": "none",
 * 		"width": 16.428571701049805,
 * 		"height": 8.571428298950195
 * 	},
 * 	"#Rectangle_20294": {
 * 		"type": "SELECTOR",
 * 		"constraint": "none",
 * 		"width": 20,
 * 		"height": 10
 * 	},
 * 	"transforms": {},
 * 	"tProps": {
 * 		"type": "PROPS",
 * 		"onAnimationComplete?": "() => void"
 * 	},
 * 	"#Import_Sm": {
 * 		"type": "SELECTOR",
 * 		"constraint": "none",
 * 		"width": 40,
 * 		"height": 40
 * 	},
 * 	"#Rectangle_20293": {
 * 		"type": "SELECTOR",
 * 		"constraint": "none",
 * 		"width": 40,
 * 		"height": 40
 * 	}
 * }
 * ---------------------------------
 *
 * DESCRIPTION
 * ---------------------------------
 * No description provided!
 * ---------------------------------
 */

/** Component Properties Interface */
export type tProps = {
  style?: tStyle;
  svgStyle?: tStyle;
  debug?: boolean;
  isInsideScrollView?: boolean;
  svgRef?: () => void;
  onAnimationComplete?: () => void;
};
/***/

/***/

export type tStyle = StyleProp<ViewStyle>;
export type tTextStyle = StyleProp<TextStyle>;
/** Convenience for prop insertion from ast (no-color-literals/no-inline-styles) */

/* eslint-disable react-native/no-color-literals */

/* eslint-disable react-native/no-inline-styles */

/** Local Styles */

const kLocalStyles = StyleSheet.create({
  kOverlay: {
    left: 0,
    position: "absolute",
    top: 0,
  },
});
/***/

/***/

/**
 * Auto-Generated Imp.Blue Component based on your design!
 * @param {tProps} props Developer interface to the component!
 * @returns {JSX.Element} JSX
 *
 * Description --
 * No description provided!
 */

export const Import_Sm = (props: {
  style?: tStyle;
  svgStyle?: tStyle;
  debug?: boolean;
  isInsideScrollView?: boolean;
  svgRef?: () => void;
  onAnimationComplete?: () => void;
}): JSX.Element => {
  const {
    style = {
      width: 30,
      height: 30,
    },
    svgStyle = {
      width: "100%",
      height: "100%",
    },
    svgRef,
  } = props;
  /** Component Internal State */

  /** Component Internal Functions */

  /** Custom React-Hooks */

  /** End Custom React-Hooks */

  /** Component Render (Javascript-React Markup) */

  if (Platform.OS === "web") {
    return (
      <View style={style}>
        <Svg fill="none" id="svg_root" ref={svgRef} {...props} style={svgStyle}>
          <G id="Import_Sm">
            <Svg preserveAspectRatio="none" viewBox="0 0 40 40">
              <Path
                id="Rectangle_20293"
                transform="rotate(90 39.5 0.5)"
                stroke="#2C4B46"
                d="M41 0.5 H77 a1.5,1.5 0 0 1 1.5,1.5 V38 a1.5,1.5 0 0 1 -1.5,1.5 H41 a1.5,1.5 0 0 1 -1.5,-1.5 V2 a1.5,1.5 0 0 1 1.5,-1.5z"
                strokeWidth="1"
                vectorEffect="non-scaling-stroke"
              />
            </Svg>
            <Svg preserveAspectRatio="none" viewBox="0 0 40 40">
              <G id="Group_2052">
                <Svg preserveAspectRatio="none" viewBox="0 0 40 40">
                  <Path
                    id="Vector"
                    d="M19.923 11.9811L19.923 10.8561L19.088 11.6099L16.5539 13.8976C16.5375 13.9124 16.5125 13.9124 16.496 13.8976C16.477 13.8804 16.477 13.8506 16.496 13.8334L19.9965 10.6733L23.5036 13.8337C23.5227 13.8509 23.5227 13.8808 23.5037 13.898C23.4872 13.9128 23.4622 13.9128 23.4457 13.898L20.904 11.6095L20.0694 10.8581L20.0694 11.9811L20.0694 25.8553C20.0694 25.8958 20.0366 25.9285 19.9962 25.9285C19.9558 25.9285 19.923 25.8958 19.923 25.8553L19.923 11.9811Z"
                    fill="#2C4B46"
                    stroke="#2C4B46"
                    strokeWidth="1"
                    vectorEffect="non-scaling-stroke"
                  />
                </Svg>
                <Svg preserveAspectRatio="none" viewBox="0 0 40 40">
                  <Path
                    id="Rectangle_20294"
                    d="M14 20.0002H10V30.0002H30V20.0002H26 L26 20.0002H30V30.0002H10V20.0002H14"
                    stroke="#2C4B46"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                    vectorEffect="non-scaling-stroke"
                  />
                </Svg>
              </G>
            </Svg>
            <Path
              d="M2 1H38V-1H2V1ZM39 2V38H41V2H39ZM38 39H2V41H38V39ZM1 38V2H-1V38H1ZM2 39C1.44772 39 1 38.5523 1 38H-1C-1 39.6569 0.343147 41 2 41V39ZM39 38C39 38.5523 38.5523 39 38 39V41C39.6569 41 41 39.6569 41 38H39ZM38 1C38.5523 1 39 1.44772 39 2H41C41 0.343146 39.6569 -1 38 -1V1ZM2 -1C0.343146 -1 -1 0.343147 -1 2H1C1 1.44772 1.44772 1 2 1V-1Z"
              fill="#2C4B46"
              id="Import_Sm_elem0"
              strokeWidth="1"
              vectorEffect="non-scaling-stroke"
            />
          </G>
        </Svg>
      </View>
    );
  }

  return (
    <View style={style}>
      <Svg
        id="native_constraint_wrapper"
        preserveAspectRatio="none"
        viewBox="0 0 40 40"
        style={[svgStyle, kLocalStyles.kOverlay]}
      >
        <Path
          id="Rectangle_20293"
          transform="rotate(90 39.5 0.5)"
          stroke="#2C4B46"
          d="M41 0.5 H77 a1.5,1.5 0 0 1 1.5,1.5 V38 a1.5,1.5 0 0 1 -1.5,1.5 H41 a1.5,1.5 0 0 1 -1.5,-1.5 V2 a1.5,1.5 0 0 1 1.5,-1.5z"
          strokeWidth="1"
          vectorEffect="non-scaling-stroke"
        />
      </Svg>
      <Svg
        id="native_constraint_wrapper"
        preserveAspectRatio="none"
        viewBox="0 0 40 40"
        style={[svgStyle, kLocalStyles.kOverlay]}
      >
        <G id="Group_2052">
          <Path
            id="Vector"
            d="M19.923 11.9811L19.923 10.8561L19.088 11.6099L16.5539 13.8976C16.5375 13.9124 16.5125 13.9124 16.496 13.8976C16.477 13.8804 16.477 13.8506 16.496 13.8334L19.9965 10.6733L23.5036 13.8337C23.5227 13.8509 23.5227 13.8808 23.5037 13.898C23.4872 13.9128 23.4622 13.9128 23.4457 13.898L20.904 11.6095L20.0694 10.8581L20.0694 11.9811L20.0694 25.8553C20.0694 25.8958 20.0366 25.9285 19.9962 25.9285C19.9558 25.9285 19.923 25.8958 19.923 25.8553L19.923 11.9811Z"
            fill="#2C4B46"
            stroke="#2C4B46"
            strokeWidth="1"
            vectorEffect="non-scaling-stroke"
          />
          <Path
            id="Rectangle_20294"
            d="M14 20.0002H10V30.0002H30V20.0002H26 L26 20.0002H30V30.0002H10V20.0002H14"
            stroke="#2C4B46"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
            vectorEffect="non-scaling-stroke"
          />
        </G>
      </Svg>
      <Svg
        id="native_constraint_wrapper"
        preserveAspectRatio="none"
        viewBox="0 0 40 40"
        style={[svgStyle, kLocalStyles.kOverlay]}
      >
        <Path
          d="M2 1H38V-1H2V1ZM39 2V38H41V2H39ZM38 39H2V41H38V39ZM1 38V2H-1V38H1ZM2 39C1.44772 39 1 38.5523 1 38H-1C-1 39.6569 0.343147 41 2 41V39ZM39 38C39 38.5523 38.5523 39 38 39V41C39.6569 41 41 39.6569 41 38H39ZM38 1C38.5523 1 39 1.44772 39 2H41C41 0.343146 39.6569 -1 38 -1V1ZM2 -1C0.343146 -1 -1 0.343147 -1 2H1C1 1.44772 1.44772 1 2 1V-1Z"
          fill="#2C4B46"
          id="Import_Sm_elem0"
          strokeWidth="1"
          vectorEffect="non-scaling-stroke"
        />
      </Svg>
    </View>
  );
};
/***/

export default React.memo(Import_Sm);
